import { Container } from "reactstrap";
import { dynamicImage, Image } from "../../Utils";

const LandingFooter = () => {
  return (
    <Container>
      <div className="feature-content">
        <ul className="d-flex align-items-center justify-content-between">
          <li>
            <h4>Top Trending Template</h4>
            <Image src={dynamicImage("landing-page/Vector.png")} alt="leaf golden" />
          </li>
          <li>
            <h4>Overall Best rated Template</h4>
            <Image src={dynamicImage("landing-page/Vector.png")} alt="leaf golden" />
          </li>
          <li>
            <h4>Themeforest Template</h4>
            <Image src={dynamicImage("landing-page/Vector.png")} alt="leaf golden" />
          </li>
        </ul>
      </div>
    </Container>
  );
};

export default LandingFooter;
